import { render, staticRenderFns } from "./DisbursingCollectionInformation.vue?vue&type=template&id=550aa84b&scoped=true"
import script from "./DisbursingCollectionInformation.vue?vue&type=script&lang=js"
export * from "./DisbursingCollectionInformation.vue?vue&type=script&lang=js"
import style0 from "./DisbursingCollectionInformation.vue?vue&type=style&index=0&id=550aa84b&prod&lang=css"
import style1 from "./DisbursingCollectionInformation.vue?vue&type=style&index=1&id=550aa84b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550aa84b",
  null
  
)

export default component.exports